import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";

import { PaysApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { PaysDetailPage } from "./PaysDetailPage";

interface IPaysItemPageProps {}

export const PaysItemPage: React.FunctionComponent<IPaysItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const paysApi = useApiService(PaysApi);
  const [displayName] = useApiEffect(() => paysApi.paysGetDisplayName({ id: id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Pays), route: ERoutes.pays },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsPays"
        onChange={newTabId => history.push(`${ERoutes.pays}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.pays}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<PaysDetailPage idPays={id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
